var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGala(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.192 11.115 2.127 1.08-.924.536-3.355 1.946-.631.364a6125.73 6125.73 0 0 1-8.318-4.82C6.67 9.396 5.25 8.57 3.827 7.746 8.057 5.388 12.093 3.151 16.372 1c2.637 1.213 5.122 2.61 7.624 4.018.958.539 1.918 1.079 2.89 1.61l.43.226c.566.297 1.122.59 1.686.88l-2.03 1.217-2.091-1.154-8.423-4.56-8.51 4.572 8.51 4.862.632-.377.656-.352 1.446-.825zm-8.303 4.472 2.916 1.678v10.089L5.042 21.98V9.924L3 8.707v14.417l12.69 7.67V16.035l-4.8-2.758v2.309zm6.296.462v5.615l1.8-.888v-3.282c1.525-1.02 3.128-1.923 4.748-2.835 1.335-.751 2.68-1.51 4.003-2.344v9.725c-1.49.94-2.988 1.848-4.476 2.751-2.058 1.25-4.099 2.488-6.074 3.78V31c2.098-1.724 4.634-3.133 7.151-4.531 1.903-1.058 3.795-2.11 5.48-3.286V8.767l-12.63 7.282z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGala);
export default __webpack_public_path__ + "static/media/GALA.90de5c1bb3269c649ed7b1591267280b.svg";
export { ForwardRef as ReactComponent };